module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "anchor-center"
  }, [_c('xi-top'), _vm._v(" "), _c('div', {
    staticClass: "center-container"
  }, [_c('div', {
    staticClass: "top-out-wrapper"
  }, [_c('div', {
    staticClass: "top-bg-wrapper"
  }, [_c('div', {
    staticClass: "top-inner-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.userObj.userPortrait100
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top-center-wrapper"
  }, [_c('span', [_vm._v(_vm._s(_vm.userObj.nickname))]), _vm._v(" "), _c('div', {
    staticClass: "authorization"
  }, [_c('span', {
    staticClass: "margin-right: 5px;"
  }, [_vm._v(_vm._s(_vm.getLabel))]), _vm._v(" "), _c('i', {
    staticClass: "icon icon-vip",
    class: _vm.vipIconClass
  })]), _vm._v(" "), _c('div', {
    staticClass: "datas"
  }, [_c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'anchorMessage'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getTodoCount();
        _vm.getAvailableAnnouncement();
        _vm.readAllMessage();
      }
    }
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.unReadMessageCount))]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.message')))])]), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'anchorTodo'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNewStatus();
      }
    }
  }, [_c('div', {
    staticClass: "data-wrapper"
  }, [(_vm.todos[1] > 0) ? _c('span', {
    staticClass: "data-alert"
  }, [_vm._v("收到新的任务邀约")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.todos[0]))])]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.todo')))])]), _vm._v("\n                            <"), _vm._v(" "), _c('router-link', {
    staticClass: "item",
    attrs: {
      "to": {
        name: 'anchorAnnouncement'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNewStatus();
      }
    }
  }, [_c('span', {
    staticClass: "data"
  }, [_vm._v(_vm._s(_vm.unReadAnnouncement))]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.announcement')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "top-tail-wrapper"
  }, [_c('a', {
    attrs: {
      "href": ((_vm.$store.state.A_PC_HOST) + "/requirementview")
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('comb.toFindTask')))])]), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.toShowVacationDialog
    }
  }, [_vm._v(_vm._s(_vm.$t('word.vacate')))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content-out-wrapper"
  }, [_c('div', {
    staticClass: "content-inner-wrapper"
  }, [_c('div', {
    staticClass: "content-left"
  }, [_c('div', {
    staticClass: "center-works-category"
  }, [(_vm.userObj.level >= 0) ? _c('router-link', {
    attrs: {
      "active-class": "active",
      "to": {
        name: 'anchorAuditionTasks'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNewStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-audition-participation va-mid mr10"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('comb.myAudition')))])]) : _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-audition-participation va-mid mr10"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('comb.myAuditionTask')))])]), _vm._v(" "), (_vm.userObj.level >= 0) ? _c('router-link', {
    attrs: {
      "active-class": "active",
      "to": {
        name: 'anchorMyAudioBook'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNewStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-my-audio-book va-mid mr10"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('comb.myTask')))])]) : _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-my-audio-book va-mid mr10"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('comb.myTask')))])]), _vm._v(" "), (_vm.userObj.level >= 0) ? _c('router-link', {
    attrs: {
      "active-class": "active",
      "to": {
        name: 'anchorMyVoiceTag'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.getNewStatus($event)
      }
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-voice-tag va-mid mr10"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('comb.myVoiceTag')))])]) : _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _c('i', {
    staticClass: "icon icon-20 icon-voice-tag va-mid mr10"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('comb.myVoiceTag')))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/center/tradeRecord",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-20 icon-earning-detail va-mid mr10"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('comb.earningDetail')))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/center/dataAnalyze/dataPreview",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-20 icon-data-analysis va-mid mr10"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('comb.dataAnalysis')))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.ximalaya.com/center/podcast",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "sticker"
  }), _vm._v(" "), _c('i', {
    staticClass: "icon icon-20 icon-broadcast va-mid mr10"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('word.popularize')))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('router-view')], 1)])])]), _vm._v(" "), _c('xi-footer'), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "close-on-click-modal": false,
      "custom-class": "announcement-pop",
      "show-close": false,
      "top": "30%"
    },
    model: {
      value: (_vm.showLastAnnouncement),
      callback: function($$v) {
        _vm.showLastAnnouncement = $$v
      },
      expression: "showLastAnnouncement"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.announcement')))]), _vm._v(" "), _c('div', {
    staticClass: "announcement",
    slot: "default"
  }, [_c('div', {
    staticClass: "title"
  }, [(_vm.lastAnnouncement) ? _c('span', [_vm._v(_vm._s(_vm.lastAnnouncement.title))]) : _vm._e()]), _vm._v(" "), (_vm.lastAnnouncement) ? _c('p', [_vm._v(_vm._s(_vm.lastAnnouncement.content))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "pop-button",
    on: {
      "click": _vm.closeAnnouncementPop
    }
  }, [_vm._v(_vm._s(_vm.$t('word.close')))])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "close-on-click-modal": false,
      "custom-class": "vacate-pop",
      "show-close": false,
      "top": "30%",
      "size": "tiny"
    },
    model: {
      value: (_vm.showVacateDialog),
      callback: function($$v) {
        _vm.showVacateDialog = $$v
      },
      expression: "showVacateDialog"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t('word.vacate')))]), _vm._v(" "), _c('div', {
    staticClass: "vacate",
    slot: "default"
  }, [_c('div', {
    staticClass: "vacation-row"
  }, [_c('span', [_vm._v("请假人：")]), _c('span', [_vm._v(_vm._s(_vm.$store.state.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "vacation-row"
  }, [_c('span', [_vm._v("请假作品：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "multiple": "",
      "placeholder": "请选择请假作品",
      "loading": _vm.isVacationLoading
    },
    model: {
      value: (_vm.vacations),
      callback: function($$v) {
        _vm.vacations = $$v
      },
      expression: "vacations"
    }
  }, _vm._l((_vm.requirementList), function(item) {
    return _c('el-option', {
      attrs: {
        "size": "small",
        "label": item.name,
        "value": item.requirementId
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "vacation-row"
  }, [_c('span', [_vm._v("请假时间：")]), _vm._v(" "), _c('el-date-picker', {
    attrs: {
      "size": "small",
      "type": "daterange",
      "placeholder": "选择请假的日期范围"
    },
    model: {
      value: (_vm.vacationDate),
      callback: function($$v) {
        _vm.vacationDate = $$v
      },
      expression: "vacationDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vacation-row"
  }, [_c('span', [_vm._v("补充说明：")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 2,
        maxRows: 4
      },
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "pop-button",
    on: {
      "click": _vm.setVacationApply
    }
  }, [_vm._v(_vm._s(_vm.$t('word.ok')))]), _vm._v(" "), _c('button', {
    staticClass: "pop-button",
    on: {
      "click": function($event) {
        _vm.showVacateDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.close')))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bbdde23c!./~/vue-loader/lib/selector.js?type=template&index=0!./views/anchor/center/CenterCommon.vue
// module id = 398
// module chunks = 0